<template>
  <div class="company-placeholder">
    <div class="company-placeholder__icon">
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 0C7.5 0 2.8605 4.15333 0.26775 6.40267C0.1155 6.54578 0 6.75422 0 7C0 7.43011 0.33525 7.77778 0.75 7.77778H2.25V13.2222C2.25 13.6523 2.58525 14 3 14H5.25C5.66475 14 6 13.6516 6 13.2222V10.1111H9V13.2222C9 13.6516 9.33525 14 9.75 14H12C12.4148 14 12.75 13.6523 12.75 13.2222V7.77778H14.25C14.6648 7.77778 15 7.43011 15 7C15 6.75422 14.8845 6.54578 14.7128 6.40267C12.138 4.15333 7.5 0 7.5 0Z"
          fill="#64748B"
        />
      </svg>
    </div>
    <div class="company-placeholder__text">
      {{ $t('header.company_placeholder') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderCompanyPlaceholder',
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.company-placeholder {
  display: flex;
  align-items: center;
  &__icon {
    width: 27px;
    height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    background-color: #ffffff;
    border-radius: 8px;
    margin-right: 10px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    font-weight: 600;
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    color: $h2;
  }
}
</style>
